import React from 'react';
import LiveSessionView from './LiveSessionView';

const LiveSessionContainer = (props) => {
  return <LiveSessionView {...props} />;
};

export default LiveSessionContainer;
